export default __webpack_public_path__ + "static/media/17.200d3fdd.svg";